import React from "react";
import PageHeader from "components/UniversalComponents/PageHeader";
import { formatBackEndDateDDMMYY } from "utlis/utils";

function Header({ last_updated_at }) {

  const showSubHeader = () => {
    if(last_updated_at) {
      return `Based on Claims data received till ${
          last_updated_at && formatBackEndDateDDMMYY(last_updated_at)
        }`
    } return ""
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <PageHeader
        header="Summary"
        subheader={showSubHeader()}
        styles={{ marginBottom: "0px" }}
      />
    </div>
  );
}

export default Header;
